import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
import { logger } from "@/lib/logger";

export function PageViewTracker() {
  const { pathname, search, key } = useLocation();
  const prevKey = useRef<string | null>(null);

  useEffect(() => {
    console.log("****************** PageViewTracker *****************");
    if (typeof window === "undefined") return; // SSR guard
    if (prevKey.current === key) return; // avoid duplicates for same entry
    prevKey.current = key;

    // Run after paint so Helmet/meta updates have applied
    const raf = requestAnimationFrame(() => {
      const url = window.location.href;
      const title = document.title;

      // Fire-and-forget; handle async errors explicitly
      console.log(`logging event for ${title}`);

      trackEvent("page_view", {
        page_location: url,
        page_path: pathname + search,
        page_title: title,
        page_referrer: document.referrer || undefined,
      }).catch((err: unknown) => {
        logger.error("trackEvent(page_view) failed:", err);
      });
    });

    return () => cancelAnimationFrame(raf);
  }, [pathname, search, key]);
  return null;
}
